module.exports = {"id":"dp2_5l1q2","text":"Digital Behaviour","instructions":"How important is it to give others space to share their opinions online?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"2.5","questionType":"Scale","random":false,"options":[{"id":"dp2_5l1q2-a1","text":"Very unimportant","score":0},{"id":"dp2_5l1q2-a2","text":"Unimportant","score":0.4},{"id":"dp2_5l1q2-a3","text":"Neutral","score":1},{"id":"dp2_5l1q2-a4","text":"Important","score":1.6},{"id":"dp2_5l1q2-a5","text":"Very important","score":2}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.5/l1q2.json
// module id = 1068
// module chunks = 41